import React from "react";
import {IonButton, IonIcon} from "@ionic/react";
import { create } from "ionicons/icons";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    onClick?: () => void,
    routerLink: string
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 31/05/2022
 * @last_update 31/05/2022
 **/
class EditButton extends React.Component<Props> {

    render() {

        return (

            <div>
                <IonButton expand="block" onClick={this.props.onClick} href={this.props.routerLink}>
                    <IonIcon icon={create} slot="start"/>
                    {this.props.t("pages.map.marker.modal.action-buttons.edit")}
                </IonButton>
            </div>

        );

    };

}

export default withTranslation()(EditButton);
